import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configuracion-inicial',
  templateUrl: './configuracion-inicial.component.html',
  styleUrls: ['./configuracion-inicial.component.scss']
})
export class ConfiguracionInicialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
